/**
 * Badge del estado de proceso de una orden (presentacional).
 *
 * Replica los "badges" de color del SSR (`progress/explore_orders_ssr.md`, §I):
 * pendiente (ámbar), en proceso/completado (azul), entregada (verde), anulada
 * (rojo). Sin lógica de negocio: recibe el estado y pinta su etiqueta/color.
 */
import { cn } from "@/components/ui";

import { STATUS_LABEL } from "../constants";
import type { OrderStatus } from "../types";

const STATUS_CLASS: Record<OrderStatus, string> = {
  pendiente: "bg-amber-100 text-amber-800",
  completado: "bg-blue-100 text-blue-800",
  entregado: "bg-green-100 text-green-800",
  anulada: "bg-red-100 text-red-800",
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        STATUS_CLASS[status],
      )}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}
